import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { invokeGetService, invokePostService, setReRender, handleSnackBar } from "../../../store/global/actions";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import { useHistory } from 'react-router-dom';
import { getDetailsFromUrl } from '../../../services/blueprint'
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import { methodSchema, pathSchema, argumentsSchema, payloadSchema, triggerEventSchema, responseEventSchema } from '../../../config/simulation';
import { findChildren, customizeEventForm, generatePayloadData, generatePayloadDataWithId, customize } from '../../../services/entities/simulations';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { Grid } from '@material-ui/core';
import './style.css';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getFirstLetterOfEachWords, validateFormValueType } from '../../../utils/commonUtils.js';

const options = {
    form_name_root: "simulation_event",
    show_errors: "never",
    disable_array_add: false,
    disable_array_reorder: true,
    disable_properties: false,
    no_additional_properties: false,
    keep_oneof_values: false,
    disable_array_delete_all_rows: true,
    disable_array_delete_last_row: true,
}

export default function SimulationEventSelector({ onClose, id, onCompletion, selectedSchema, action, simulation_transaction_id }) {
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const testcaseId = query.get('testcase')
    const {blueprintId, slug, entityId} = getDetailsFromUrl()

    const dispatch = useDispatch();
    const history = useHistory();



    const [loading, setLoading] = useState(false);
    const [schemaValues, setSchemaValues] = useState({});
    const [editorSchema, setEditorSchema] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);
    const [eventType, setEventType] = useState(undefined);
    const [allFields, setAllFields] = useState([]);
    const [constructs, setConstructs] = useState(null)
    const [formData, setFormData] = useState({});
    const [allEvents, setAllEvents] = useState([]);
    const [allMessages, setAllMessages] = useState([]);
    const [currentSelectedEvent, setCurrentSelectedEvent] = useState(id)

    const [testcaseContext, setestCaseContext] = useState([]);
    const pathSupportedProtocols = ["http_delegate", "http2_delegate", "cv_delegate"];
    let previousData = {}

    const myRef = useRef(null);

    useEffect(() => {
        loadEventInfo();
    }, [id])

    const findRoutingRuleOfSelectedEvent = (eventId, routingRules) => {
        const routingRule = routingRules.find(rrdef => rrdef?.attributes?.tcmd == eventId);
        return routingRule;
    }

    const getNestedPayloadSchemaValues = (fields, payload) => {

        const payloadSchemaData = {};

        fields?.forEach(item => {
            let itemFound = null;
            
            if(payload && payload?.length){
                itemFound = payload?.find(element => element?.field_id == item._id)

                if(!itemFound){
                    itemFound = payload?.find(element => element.field == item.name)
                }
            }
            let fieldName = item.name;

            if (item.children?.length > 0 || item.attributes.type == "struct") {
                if (itemFound != undefined && itemFound?.field_id) {
                    fieldName = allFields.find(fd => fd._id == itemFound?.field_id) ? allFields.find(fd => fd._id == itemFound?.field_id)?.name : item.name
                }

                if(item.attributes.collection ){
                    payloadSchemaData[fieldName] = []
                    if(itemFound != undefined){
                        if(itemFound?.children != undefined && itemFound?.children?.length > 0){
                            itemFound?.children?.forEach(found => {
                                const nestedData = getNestedPayloadSchemaValues(item.children, found);
                                payloadSchemaData[fieldName].push(nestedData)
                            })
                        }else{
                            let obj = {};
                            item?.children.forEach((child) => {
                                obj[child.name] = {
                                    field: child.name, 
                                    type: child?.attributes?.type,
                                    value: child.attributes?.default !== undefined ? child.attributes?.default : "", 
                                    field_id: child._id,
                                    originalType: child?.attributes?.type, 
                                }
                            })
                            payloadSchemaData[fieldName].push(obj);
                        }

                    }
                    
                    
                }else{
                    const nestedData = getNestedPayloadSchemaValues(item.children, itemFound?.children);
                    payloadSchemaData[fieldName] = { ...nestedData };
                }

            } else {
                let fieldValue;

                if(payload && itemFound?.value){
                    fieldValue = itemFound.value;
                } else if(!payload && item.attributes.default !== undefined){
                    fieldValue = item.attributes.default;
                } else if (!item.attributes.optional) {
                    fieldValue = "";
                } else {
                    fieldValue = undefined;
                }
                
                if(fieldValue !== undefined && !item.attributes.collection){
                    payloadSchemaData[item.name] = { 
                        field: item.name, 
                        type: (itemFound && itemFound?.type) ? itemFound.type : item?.attributes?.type,
                        value: fieldValue, 
                        field_id: item._id,
                        originalType: item?.attributes?.type
                    }
                }else{
                    if(item.attributes.collection){
                        payloadSchemaData[item.name] = [];
                        if(itemFound?.children?.length > 0){
                            itemFound?.children?.forEach(found => {
                                payloadSchemaData[item.name].push({ 
                                    field: item.name, 
                                    type: (found && found?.type) ? found.type : item?.attributes?.type, 
                                    value: found?.value || item.attributes.default || "", 
                                    field_id: item._id,
                                    originalType: item?.attributes?.type
                                })
                            })
                        }else{
                            payloadSchemaData[item.name].push({ 
                                field: item.name, 
                                type: item?.attributes?.type, 
                                value: item.attributes.default || "", 
                                field_id: item._id ,
                                originalType: item?.attributes?.type
                            })
                        }
                        
                    }
                }
            }
        });

        return payloadSchemaData;
    }



    // For generate payload schema values
    const generatePayloadSchemaData = (eventId, simulationTransactions, associatedFields) => {
        const simulationTransaction = simulationTransactions.find(element => {
            return element._id == simulation_transaction_id;
        });
        const selectedEventData = simulationTransaction?.events?.find(event => event.id == eventId); // Selected event object in  events of simulationTransactions
       
        const payloadschemaData = getNestedPayloadSchemaValues(associatedFields, selectedEventData?.payload);
        return payloadschemaData;
    }

    const rrdefAutomation = ({ event, transaction, srcNode, dstNode, applicationName, customSchema, blueprintId, delegateProtocols, platformSchemaDelegates }) => {
    
        try {
            const rrdefName = generateRRDefName(transaction.name, event.name);
            const delegate = srcNode.type == 1 ? srcNode : dstNode;
            const direction = srcNode.type == 1 ? "IN" : "OUT";
    
            let rrdef = {
                name: srcNode.type == 1 ? rrdefName : `${rrdefName}_out`,
                type: 13,
                attributes: {
                    delegate: delegate._id.toString(),
                    op: "POST"
                }
            }
            let rrdefSchema, defaultRrdef;
            if (customSchema) {
              ({ rrdefschema: rrdefSchema, rrdefs: defaultRrdef } = customSchema);
            } else {
              const delegateSchema = platformSchemaDelegates.find(del => del.node === delegate.attributes.type)

              if (delegateSchema) ({ rrdefschema: rrdefSchema, rrdefs: defaultRrdef } = delegateSchema?.schemaJson);
            }
    
    
            // If default rrdef already exists for this direction, skip
            if (defaultRrdef?.some(template => template?.dir === direction)) {
                return null;
            }
    
    
            if (!rrdefSchema || !Array.isArray(rrdefSchema) || !rrdefSchema.every(Array.isArray)) return null;
        
            const matchingSchemas = rrdefSchema.filter(template => {
                return template?.some(obj => obj?.name === "dir" && obj?.args?.default === direction);
            });
    
            if (!matchingSchemas.length) return null;
            const rrdefSchemaTemplate = direction === "OUT" && matchingSchemas[1] ? matchingSchemas[1] : matchingSchemas[0];
    
            for (const item of rrdefSchemaTemplate) {
              const value = getSchemaDefaultValue({
                rrdef: item,
                srcNode,
                dstNode,
                applicationName,
                rrdefName,
                event,
              });
              if (value !== undefined) rrdef.attributes[item.name] = value;
            }
              
            return rrdef;
        } catch (error) {
            throw error;
        }
    
    
    }

    const getSchemaDefaultValue = ({ rrdef, event, rrdefName, srcNode, dstNode, applicationName }) => {
        let value;
        switch(rrdef.name){
            case 'dir':
                value = srcNode.type == 1 ? 'IN' : 'OUT';
                break;
            case 'ttype':
                value = srcNode.type == 1 ? dstNode._id.toString() : srcNode._id.toString();
                break;
            case 'tcmd':
                value = event._id.toString();
                break;
            case 'name': 
                value = srcNode.type == 1 ? event.name : `${event.name}_out`;
                break;
            case 'commandtype':
                value = srcNode.type == 1 ? 'req' : 'res';
                break;
            case 'path':
                if(srcNode.type == 1){
                    value = `/iot/${applicationName}/${rrdefName}/{instance}/`
                }
                break;
            case 'tinstance':
                if(srcNode.type == 1){
                    value = `{instance}`
                }
                break;
            case 'code':
                if(srcNode.type != 1){
                    value = 200
                }
                break;
            default:
                break;
        }
    
        return value;
    }
    
    const generateRRDefName = (transactionName,eventName) => {
        try {
    
        const hashedTransaction = getFirstLetterOfEachWords(transactionName)
        return `${eventName}_${hashedTransaction}`
    
        } catch (error) {
           throw error;
        }
    }

    const dealTriggerEventSchemaData = (constructs, simulationDetails, associatedFields, platformSchemaDelegates, selectedEventDelegate) => {
        const delegateProtocols = platformSchemaDelegates.map(item => item.node)
        const simulationTransaction = simulationDetails?.data?.testcaseTransactions.find(element => {
            return element._id == simulation_transaction_id;
        });

        const selectedEventObj = constructs?.data?.events?.find(element => element._id == id); // Selected event document in events collection
        const selectedEventData = simulationTransaction?.events?.find(event => event.id == id); // Selected event object in  events of simulationTransactions

        const srcNode = constructs?.data?.clusterlets?.find(clusterlet => clusterlet._id === selectedEventObj.src)
        const dstNode = constructs?.data?.clusterlets?.find(clusterlet => clusterlet._id === selectedEventObj.dst)

        const getTransaction = (eventId) => {
            const transactions = constructs.data?.transactions;
            return transactions.find(txn =>{
                const eventIds = txn.events.map(e => e.id);
                if(eventIds.includes(eventId.toString())) return true
                else return false
            })
        }

        
        if((srcNode.type === 1 && !delegateProtocols.includes(srcNode.attributes.type)) || (dstNode.type === 1 && !delegateProtocols.includes(dstNode.attributes.type))){
            const transaction = getTransaction(selectedEventObj._id);
            if(srcNode.type === 1){
                srcNode.attributes.type = "http_delegate"
            }else{
                dstNode.attributes.type = "http_delegate"
            }

            const rrdef = rrdefAutomation({ event: selectedEventObj, srcNode, dstNode, transaction, applicationName: slug || '', blueprintId: blueprintId, delegateProtocols, platformSchemaDelegates })
            constructs.data?.routingRules?.push(rrdef)
        }

        const routingRuleOfSelectedEvent = findRoutingRuleOfSelectedEvent(id, constructs?.data?.routingRules)
        let schemaData = {};

        if (selectedEventData) {
            schemaData.event = selectedEventObj?.name ? selectedEventObj?.name : "";

            const method = selectedEventData.method ? selectedEventData.method : routingRuleOfSelectedEvent?.attributes?.op ? routingRuleOfSelectedEvent?.attributes?.op : "";
            const path = selectedEventData.path ? selectedEventData.path : routingRuleOfSelectedEvent?.attributes?.path ? routingRuleOfSelectedEvent?.attributes?.path : "";


            if (pathSupportedProtocols.includes(selectedEventDelegate?.attributes?.type) || !delegateProtocols.includes(selectedEventDelegate?.attributes?.type)) {
                schemaData.method = method;
                schemaData.path = path;
            }

            if (!method && !path) {
                dispatch(handleSnackBar({ open: true, message: `Selected event does not have a 'method' or 'path' for HTTP`, severity: "error" }));
            } else if (!method) {
                dispatch(handleSnackBar({ open: true, message: `Selected event does not have a 'method' for HTTP`, severity: "error" }));
            } else if (!path) {
                dispatch(handleSnackBar({ open: true, message: `Selected event does not have a 'path' for HTTP`, severity: "error" }));
            }

            console.log("schemaData---", schemaData)

            // For finding the schema values of arguments
            if (schemaData.path && schemaData.path !== "") {
                const regex = /\{([^}]+)\}/g;
                const matches = [...schemaData.path.matchAll(regex)];
                const pathArguments = matches.map(match => match[1]);
                if (pathArguments.length > 0) {
                    schemaData.arguments = pathArguments.map(item => {
                        const argumentObj = selectedEventData?.arguments?.find(element => element.argument == item);
                        return { argument: item, type: argumentObj?.type ? argumentObj?.type : "default", value: argumentObj?.value ? argumentObj?.value : "" };
                    });
                }
            }
            // For finding the schema values of payload
            const payloadschemaData = generatePayloadSchemaData(id, constructs?.data?.simulationTransactions, associatedFields);

            if (Object.keys(payloadschemaData)?.length > 0) {
                schemaData.payload = payloadschemaData;
            }
        }


        setSchemaValues(schemaData);
    }

    const dealResponseEventSchemaData = (constructs, associatedFields) => {
        const simulationTransaction = constructs?.data?.simulationTransactions.find(element => {
            return element._id == simulation_transaction_id;
        });
        const selectedEventData = simulationTransaction?.events?.find(event => event.id == id); // Selected event object in  events of simulationTransactions
        let schemaData = {};
        if (selectedEventData?.id !== undefined) {
            schemaData.event = {
                [selectedEventData.id]: selectedEventData.id
            }
            if (schemaData.event !== "select") {
                const payloadschemaData = generatePayloadSchemaData(id, constructs.data.simulationTransactions, associatedFields);
                if (Object.keys(payloadschemaData)?.length > 0) {
                    schemaData.event.payload = payloadschemaData;
                }
            }

        } else {
            schemaData.event = { "select": "select" };
        }
        setSchemaValues(schemaData);
    }

     const formatDateTime = (date) => {
        const pad = n => String(n).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    };

    const getCurrentDateAndTime = () => {
        const now = new Date();
        const toDate = new Date(now);
        const fromDate = new Date(now);
        fromDate.setDate(now.getDate() - 3);

        return ({fromDate,toDate})
    }

    


    const loadEventInfo = () => {

        setLoading(true)

        Promise.all([
            dispatch(invokeGetService('getBlueprintConstructs', [])),
            dispatch(invokeGetService('getCandidateEvents', [testcaseId, id])),
            dispatch(invokeGetService('getTestcaseData', [testcaseId])),
            dispatch(invokeGetService('getDelegateProtocols',[]))
        ]).then(([constructs, candidateEvents, testcaseDetails, delegateProtocolData]) => {
            setConstructs(constructs)
            myRef.current = candidateEvents?.data?.predefinedFunctions;


            const selectedEvent = constructs.data?.events?.find(event => event._id == id);
            const eventSource = constructs.data?.clusterlets?.find(clusterlet => clusterlet._id == selectedEvent.src);
            const eventDestination = constructs.data?.clusterlets?.find(clusterlet => clusterlet._id == selectedEvent.dst);

            const message = constructs?.data?.messages.find(item => item._id == selectedEvent.message);
            const nestedData = findChildren(message, [], constructs?.data?.fields, constructs?.data?.messages, false);
            const messageFields = (nestedData != undefined && nestedData.children != undefined) ? nestedData.children : [];

            if (eventSource?.type === 1) {
                findEventTriggerSchema(eventSource, messageFields, delegateProtocolData?.data);
                setEventType("trigger");
                dealTriggerEventSchemaData(constructs, testcaseDetails, messageFields, delegateProtocolData?.data, eventSource);
            } else if (eventDestination?.type === 1) {
                findEvenResponseSchema(candidateEvents?.data?.candidateEvents, constructs?.data?.fields, constructs?.data?.messages, constructs?.data?.simulationTransactions, constructs?.data?.transactions);
                setEventType("response");
                dealResponseEventSchemaData(constructs, messageFields);
            }
            setAllFields(constructs?.data?.fields);
            setAllEvents(constructs.data?.events)
            setAllMessages( constructs?.data?.messages);
            setestCaseContext(testcaseDetails?.data?.testcase?.context || [])
            setLoading(false)
        });
    }

    // Defining schema for the editor
    const findEvenResponseSchema = (candidateEvents, fields, messages, simulationTransactions, transactions) => {
        const simTxn = simulationTransactions.find((transaction) => {
            let transactionEvents = transaction.events?.map(item => item.id)
            if(transactionEvents.includes(candidateEvents?.[0]?._id)){
                return transaction
            }
        });

        const transaction = transactions?.find(item => item._id === simTxn.transaction_id);

        const responseEventSchemaObj = responseEventSchema(candidateEvents, fields, messages, transaction?.oneof);
        const schema = { ...responseEventSchemaObj, properties: { ...responseEventSchemaObj.properties } };
        setEditorSchema(schema);
    }
    
    const findEventTriggerSchema = (selectedEventDelegate, messageFields, platformSchemaDelegates) => {
        const delegateProtocols = platformSchemaDelegates.map(protocol => protocol.node)
        let schema = { ...triggerEventSchema };
        if (pathSupportedProtocols.includes(selectedEventDelegate?.attributes?.type) || !delegateProtocols.includes(selectedEventDelegate?.attributes?.type)) {
            schema = { ...schema, properties: { ...schema.properties, ...methodSchema, ...pathSchema, ...argumentsSchema(myRef.current) } };
        }

        const payloadSchemaObj = payloadSchema(messageFields, myRef.current);
        schema = { ...schema, properties: { ...schema.properties, ...payloadSchemaObj } };

        setEditorSchema(schema);
    }

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const onChangeJsonEditor = (data) => {
        const dataKeys = Object.keys(data?.event || {})
        if(dataKeys[0] && currentSelectedEvent && dataKeys[0] !== currentSelectedEvent){
            const selectedEvent = constructs.data?.events?.find(event => event._id === dataKeys[0]);

            if(selectedEvent){
                const message = constructs?.data?.messages.find(item => item._id === selectedEvent?.message);
                const nestedData = findChildren(message, [], constructs?.data?.fields, constructs?.data?.messages, false);
                const messageFields = (nestedData !== undefined && nestedData.children !== undefined) ? nestedData.children : [];
                data.event.payload = generatePayloadSchemaData(dataKeys[0], constructs?.data?.simulationTransactions, messageFields);
            }
        }
        if (data.arguments !== undefined && data.arguments !== 0) {
            handleArgumentsForRandomFunctions(data)
        }


        const payload = data.payload
        if (payload !== undefined) {
            data.payload = handlePayloadForRandomFunctions(payload)
        }

        setFormData(data);
        customizeEventForm(data);
        customize(data, 'simulation_event')
        previousData = data

    }

    const handleArgumentsForRandomFunctions = (data) => {

        let rrdef_arguments = previousData?.arguments !== undefined ? previousData.arguments : []

        data.arguments.map(field => {

            const previousField = rrdef_arguments.find(arg => arg.argument === field.argument)

            if (previousField !== undefined && previousField.type === field.type) {
                return;
            }

            const functionNames = myRef.current.map(item => item.function_name)

            if (functionNames.includes(field.type)) {
                let fieldIndex = data.arguments.findIndex(item => item.type === field.type && item.argument === field.argument)
                let selectedFunction = myRef.current.find(item => item.function_name === field.type)
                if (selectedFunction.function_name === "hbx_random_dates") {
                    let {fromDate,toDate} = getCurrentDateAndTime();
                    selectedFunction.arguments.from = formatDateTime(fromDate, 11, 0); 
                    selectedFunction.arguments.to = formatDateTime(toDate, 12, 0);
                }

                if(field.type == "hbx_media" && field?.originalType == "audio"){
                    selectedFunction.arguments.type = "audio"
                }

                if (document.getElementById(`simulation_event[arguments][${fieldIndex}][value]`)) {

                    document.getElementById(`simulation_event[arguments][${fieldIndex}][value]`).value = JSON.stringify(selectedFunction.arguments);
                    field.value = JSON.stringify(selectedFunction.arguments);

                    //Have to optimize
                    const prevValue = document.getElementById(`simulation_event[arguments][${fieldIndex}][value]`).value
                    if (!(prevValue[0] == "{" && prevValue[prevValue.length - 1] == "}")) {
                        document.getElementById(`simulation_event[arguments][${fieldIndex}][value]`).value = JSON.stringify(selectedFunction.arguments);
                        field.value = JSON.stringify(selectedFunction.arguments);
                    }

                }
            } else {

                let fieldIndex = data.arguments.findIndex(item => item.type == field.type)

                if (document.getElementById(`simulation_event[arguments][${fieldIndex}][value]`)) {

                    document.getElementById(`simulation_event[arguments][${fieldIndex}][value]`).value = "";
                    field.value = "";

                    const prevValue = document.getElementById(`simulation_event[arguments][${fieldIndex}][value]`).value
                    document.getElementById(`simulation_event[arguments][${fieldIndex}][value]`).value = prevValue != "" ? prevValue : "";
                    field.value = prevValue !== "" ? prevValue : "";
                }
            }
            return field
        })
    }

    const handlePayloadForRandomFunctions = (data, prevField, prevClassKeys) => {

        const functionNames = myRef.current.map(item => item.function_name)

        Object.keys(data).forEach((key, index) => {
            let field = data[key];
            let classIntermediate = prevClassKeys ? [...prevClassKeys, key] : [key]
            if (typeof field === 'object' && !('field' in field) && !('field_id' in field) && !('type' in field)) {
                field = handlePayloadForRandomFunctions(field, prevField?.[key] || previousData?.payload?.[key], classIntermediate)
            }
            // const previousField = previousData.payload !== undefined ? previousData.payload[field.field] : { type : null}
            const previousField = prevField?.[key] ? prevField?.[key] : previousData.payload !== undefined ? previousData.payload[key] : { type: null }

            if (previousField !== undefined && previousField.type === field.type) {
                return;
            }

            if (previousField?.type == null) {
                return;
            }

            let idFinder = ''
            for (let i = 0; i < classIntermediate.length; i++) {
                idFinder += `[${classIntermediate[i]}]`
            }
            if (functionNames.includes(field.type)) {
                let selectedFunction = myRef.current.find(item => item.function_name == field.type)

                if (selectedFunction.function_name === "hbx_random_dates") {
                    let {fromDate,toDate} = getCurrentDateAndTime();
                    selectedFunction.arguments.from = formatDateTime(fromDate, 11, 0); 
                    selectedFunction.arguments.to = formatDateTime(toDate, 12, 0);
                }

                if(field.type === "hbx_media" && field?.originalType === "audio"){
                    selectedFunction.arguments.type = "audio"
                }
                if (document.getElementById(`simulation_event[payload]${idFinder}[value]`)) {

                    //Have to optimize
                    const prevValue = document.getElementById(`simulation_event[payload]${idFinder}[value]`).value
                    if (!(prevValue[0] === "{" && prevValue[prevValue.length - 1] === "}")) {

                        document.getElementById(`simulation_event[payload]${idFinder}[value]`).value = JSON.stringify(selectedFunction.arguments);
                        field.value = JSON.stringify(selectedFunction.arguments);
                        data[key].value = JSON.stringify(selectedFunction.arguments);
                    } else {
                        document.getElementById(`simulation_event[payload]${idFinder}[value]`).value = JSON.stringify(selectedFunction.arguments);
                        field.value = JSON.stringify(selectedFunction.arguments);
                    }

                }



            } else {

                

                if (document.getElementById(`simulation_event[payload]${idFinder}[value]`)) {
                    const prevValue = document.getElementById(`simulation_event[payload]${idFinder}[value]`).value
                    document.getElementById(`simulation_event[payload]${idFinder}[value]`).value = prevValue != "" ? prevValue : "";
                    data[key].value = prevValue != "" ? prevValue : "";

                    if (field.type.includes('hbx_') == false && field.value.includes("{")) {
                        document.getElementById(`simulation_event[payload]${idFinder}[value]`).value = "";
                    }

                }
            }

        })



        return data
    }


    function transformData(input) {
        let output = [];

        function traverse(obj, parentKey = "") {
            let index = 0;
            for (let key in obj) {
                if (typeof obj[key] === "object") {
                    if (obj[key].hasOwnProperty("children")) {
                        traverse(obj[key].children, parentKey !== "" ? `${parentKey}[${obj[key].field}]` : `[${obj[key].field}]`);
                    } else {
                        if(Array.isArray(obj[key])){
                            traverse(obj[key],  `${parentKey}[${index}]` )
                        }else{
                            let newKey = parentKey !== "" ? `${parentKey}[${obj[key].field || index}]` : `[${obj[key].field || index}]`;
                            obj[key].key = newKey;
                            output.push(obj[key]);
                        }
                    }
                }
                index++;
            }
        }

        traverse(input);
        
        return output;
    }

    const clearErrors = () => {
        const errorDivs = document.querySelectorAll('.validation-error');
        for (let i = 0; i < errorDivs.length; i++) {
            errorDivs[i].remove();
        }
    };

    const onUpdateEvent = () => {
        setIsUpdating(true);
        clearErrors();
        let eventData = {};
        if (eventType === "response") {
            eventData.id = Object.keys(formData.event)[0];
            if (formData.event.payload) {
                const payloadData = generatePayloadData(formData.event.payload);
                eventData.payload = payloadData;
            }
        } else {
            eventData.id = id;
            if (formData.payload) {
                const eventMessage = allEvents.find(ev => ev._id === id) ? allEvents.find(ev => ev._id === id)?.message : "";
                const payloadData = generatePayloadDataWithId(formData.payload, eventMessage, allFields, allMessages)
                eventData.payload = payloadData;
            }
        }

        if (eventData.id === 'select' || eventData.id === undefined) {
            const eventDropdown = document.querySelector('select.form-control.je-switcher');
            if (eventDropdown) {
                const validateError = document.getElementById("event-validation-error");
                if (validateError === null) {
                    eventDropdown.insertAdjacentHTML('afterend', `<p id="event-validation-error" class="text text-danger validation-error" >Please select event</p>`);
                }
            }
            setIsUpdating(false);
            return;
        }
        const flattenPayload = transformData(eventData.payload)
        const validationErrors = validateFormValueType(flattenPayload);
        if (validationErrors.length > 0) {
            validationErrors.forEach(item => {
                const  inputElementId = eventType === "trigger" ? `simulation_event[payload]${item.key}[value]` :
                                                                `simulation_event[event][payload]${item.key}[value]`
                const inputField = document.getElementById(inputElementId);
                if (inputField) {
                    inputField.insertAdjacentHTML('afterend', `<p id="validation-error-${item.key}" class="text text-danger validation-error" >${item.message}</p>`);
                }
            });
            setIsUpdating(false);
            return;
        }

        if (formData.path) eventData.path = formData.path;
        if (formData.method) eventData.method = formData.method;

        if (formData.arguments?.length > 0) {
            eventData.arguments = formData.arguments;
        }

        dispatch(invokePostService('updateEventInSimulationTransaction', { eventData: eventData, oldEventId: id, testsuiteId: entityId }, [testcaseId, simulation_transaction_id])).then(response => {
            setIsUpdating(false);
            if (response.status === true) {
                onCompletion('Event payload', 'edit');
            } else {
                if (response.code === 255) {
                    const { slug, blueprintId } = getDetailsFromUrl();
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                }
            }
        });
    }

    return (

        <>
            {loading && <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '35vh' }} />}
            {!loading && <>
                <JsonTableEditor options={options} schema={editorSchema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId={eventType === 'trigger' ? "trigger_event_editor" : "response_event_editor"} contextData={testcaseContext} />
            </>}
            <Grid item xs={12} style={loading ? { display: "flex", justifyContent: "flex-end", marginBottom: 20, marginTop: "30vh" } : { display: "flex", justifyContent: "flex-end", marginTop: 30 }}>
                <UpdateCancel updateDisable={isUpdating || loading} content={isUpdating ? 'Updating..' : 'Update'} onUpdate={onUpdateEvent} onCancel={onClose} typesNotIn={['transaction', 'view', 'simulation']} />
            </Grid>
        </>



    )



}